try {
(function(){
  // Unit prices and currency come from Shopify via window.LYS_PRICES (lys-v4-scripts.liquid), in the visitor's local
  // currency (Shopify Markets). Package totals use the matching package variant's price when it is known; otherwise they are
  // derived from the unit prices and the card's data-rate, with unit prices rounded down to whole currency units.
  var P = window.LYS_PRICES || { currency: 'GBP', v1: 300, pro: 700 };
  var V1_PRICE = P.v1, PRO_PRICE = P.pro;
  var LOCALES = { GBP: 'en-GB', EUR: 'en-IE', DKK: 'da-DK', USD: 'en-US', SEK: 'sv-SE', NOK: 'nb-NO' };
  function money(n){ return new Intl.NumberFormat(LOCALES[P.currency] || 'en-GB', { style: 'currency', currency: P.currency, maximumFractionDigits: 0 }).format(n); }

  // composition -> Shopify variant id and price, read from each package product's JSON (variant titles match these labels)
  var VARIANTS = {};
  function compoLabel(v1, pro){ return pro === 0 ? v1 + ' × Button V1' : v1 === 0 ? pro + ' × Button PRO' : v1 + ' × V1 + ' + pro + ' × PRO'; }
  function variantFor(href, v1, pro){ var m = VARIANTS[href]; return m && m[compoLabel(v1, pro)]; }
  function loadVariants(href, done){
    if (!window.fetch) return;
    fetch(href + '.js').then(function(r){ return r.ok ? r.json() : null; }).then(function(p){
      if (!p) return; var m = {}; p.variants.forEach(function(v){ m[v.title] = { id: v.id, price: v.price / 100 }; }); VARIANTS[href] = m; done();
    }).catch(function(){});
  }

  function recalcCard(select){
    var tier = select.getAttribute('data-tier');
    var rate = parseFloat(select.getAttribute('data-rate')) || 0;
    var parts = select.value.split(',');
    var v1 = parseInt(parts[0], 10) || 0;
    var pro = parseInt(parts[1], 10) || 0;
    var total = v1 + pro;
    var subtotal = v1 * V1_PRICE + pro * PRO_PRICE;
    var v1Unit = Math.floor(V1_PRICE * (1 - rate)), proUnit = Math.floor(PRO_PRICE * (1 - rate));
    var grandTotal = v1 * v1Unit + pro * proUnit;
    var buy = document.getElementById('pkBuy-' + tier);
    var baseHref = buy && buy.getAttribute('data-href');
    var variant = baseHref ? variantFor(baseHref, v1, pro) : null;
    if (variant && variant.price > 0) grandTotal = variant.price;   // the price the customer will actually pay
    var discountAmt = subtotal - grandTotal;
    var perSensor = total > 0 ? grandTotal / total : 0;
    var isDefault = select.selectedIndex === 0;

    var totalEl = document.getElementById('pkTotal-' + tier);
    if (totalEl) totalEl.textContent = money(grandTotal);
    var fromLabel = document.getElementById('pkFromLabel-' + tier);
    if (fromLabel) fromLabel.style.display = isDefault ? '' : 'none';
    var saveEl = document.getElementById('pkSave-' + tier);
    if (saveEl) saveEl.textContent = rate > 0 ? (Math.round(rate * 1000) / 10) + '% off · save ' + money(discountAmt) : 'List price, no volume tier yet';
    var wasEl = document.getElementById('pkWas-' + tier);
    if (wasEl) wasEl.textContent = money(subtotal);
    var perEl = document.getElementById('pkPer-' + tier);
    if (perEl && total > 0) perEl.textContent = (variant || (v1 > 0 && pro > 0) ? '≈ ' + money(perSensor) : pro === 0 ? money(v1Unit) : money(proUnit)) + ' per Button';

    if (buy) {
      var label = buy.getAttribute('data-label') || 'Buy package';
      buy.textContent = label + ' · ' + money(grandTotal);
      if (baseHref) buy.setAttribute('href', variant ? baseHref + '?variant=' + variant.id : baseHref);
    }

    document.querySelectorAll('.quote-trigger[data-tier="' + tier + '"]').forEach(function(qt){
      qt.setAttribute('data-v1', v1);
      qt.setAttribute('data-pro', pro);
    });
  }

  document.querySelectorAll('.pk-compo-select').forEach(function(sel){
    recalcCard(sel);
    sel.addEventListener('change', function(){ recalcCard(sel); });
  });
  var hrefs = {};
  [].forEach.call(document.querySelectorAll('.pk-buy-link[data-href]'), function(a){ hrefs[a.getAttribute('data-href')] = 1; });
  Object.keys(hrefs).forEach(function(h){ loadVariants(h, function(){ document.querySelectorAll('.pk-compo-select').forEach(recalcCard); }); });
})();
} catch (e) { console.error("lys-v4 pricing", e); }
